import React from 'react';
import Gallery from './Gallery';
import ScrollReveal from './ScrollRevealImage';
import HoverSwap from './HoverSwap';
import galleryConfig from './galleryConfig.json';
import './app.css';

const Ghost = ({ src, hoverSrc, direction, size, offset = 0, className }) => (
  <div className="ghost-block">
    <ScrollReveal direction={direction} size={size} offset={offset} className={className}>
      <HoverSwap 
        hoverContent={<img src={hoverSrc} alt="Ghost" />}
        animationClass="ghost-wobble"
      >
        <img src={src} alt="Ghost" />
      </HoverSwap>
    </ScrollReveal>
  </div>
);

function App() {
  return (
    <div className="info-site">
      <header className="hero">
        <div className="hero-content">
          <img
            src="/assets/images/sprites/Text-8.png"
            width="300"
            alt="Haunted! Do Not Sit"
            className="title-image"
          />
          <p className="tagline">An arcade game hidden inside a haunted chair</p>
        </div>
      </header>

      <Ghost 
        src="/assets/images/sprites/Ghost-1.png"
        hoverSrc="/assets/images/sprites/Ghost-3.png"
        direction="left"
        size={50}
        offset={40}
        className="ghost-1"
      />

      <main className="content">
        <section className="about">
          <h2>About This Chair</h2>
          <p>
            This isn't your ordinary piece of furniture. <strong>Haunted! Do Not Sit</strong> is
            a fully playable arcade game concealed within a recycled chair, created for the &nbsp;
            <a href="https://furniturebankatlanta.org/events/chairish-the-future/" target="_blank" rel="noopener noreferrer">
              Furniture Bank of Atlanta's Chairish the Future
            </a> charity auction.
          </p>
          <p>
            Scan the QR code on the screen, and play through a spooky
            adventure. Help a little girl save her stuffed animals from a spooky
            ghosts.
          </p>
        </section>

        <Ghost 
          src="/assets/images/sprites/Ghost-4.png"
          hoverSrc="/assets/images/sprites/Ghost-6.png"
          direction="right"
          size={55}
          offset={60}
          className="ghost-2"
        />

        <section className="gallery">
          <h2>Finished Chair</h2>
          <Gallery
            title={galleryConfig.finished.title}
            description={galleryConfig.finished.description}
            items={galleryConfig.finished.items}
            featured={true}
          />
        </section>

        <Ghost 
          src="/assets/images/sprites/Ghost-7.png"
          hoverSrc="/assets/images/sprites/Ghost-9.png"
          direction="left"
          size={45}
          offset={80}
          className="ghost-3"
        />

        <section className="charity">
          <h2>Supporting Furniture Bank of Atlanta</h2>
          <p>
            The <a href="https://furniturebankatlanta.org/" target="_blank" rel="noopener noreferrer">
              Furniture Bank of Metro Atlanta
            </a> helps families and individuals in need by providing essential home furnishings.
            Their annual <strong>Chairish the Future</strong> event showcases one-of-a-kind
            artistic chairs to raise funds for their mission.
          </p>
          <a
            href="https://furniturebankatlanta.org/events/chairish-the-future/"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Learn More About Chairish the Future
          </a>
        </section>

        <Ghost 
          src="/assets/images/sprites/Ghost-10.png"
          hoverSrc="/assets/images/sprites/Ghost-12.png"
          direction="right"
          size={60}
          offset={35}
          className="ghost-4"
        />

        <section className="gallery">
          <h2>Creation of the Chair</h2>
          <Gallery
            title={galleryConfig.progress.title}
            description={galleryConfig.progress.description}
            items={galleryConfig.progress.items}
            featured={false}
          />
        </section>

        <Ghost 
          src="/assets/images/sprites/Ghost-13.png"
          hoverSrc="/assets/images/sprites/Ghost-15.png"
          direction="left"
          size={48}
          offset={55}
          className="ghost-5"
        />
      </main>

      <Ghost 
        src="/assets/images/sprites/Ghost-16.png"
        hoverSrc="/assets/images/sprites/Ghost-18.png"
        direction="right"
        size={52}
        offset={70}
        className="ghost-6"
      />

      <footer>
        <p>
          Created with 👻 for <a href="https://furniturebankatlanta.org/events/chairish-the-future/" target="_blank" rel="noopener noreferrer">Chairish the Future 2026</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
